import React, { useEffect, useState } from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa";
import { base_url } from "../utils/axiosConfig";
import { Link, useNavigate } from "react-router-dom";
import { services } from "../utils/Data";
import axios from "axios";
import { toast } from "react-toastify";

const Footer = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          `${base_url}product/getCategory?page=1&limit=100`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();

        setCategories(data?.data || []);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  // Fetch referred user data
  const subscribeNewsletter = async () => {
    try {
      const response = await axios.post(
        `${base_url}v1/user/subscribeNewsletter`,
        {
          email,
        },
      );
      setEmail("");
      toast.success(response.data.message);
    } catch (error) {
      console.error("Error fetching referred user data:", error);
      toast.error(
        error.response.data.message || "Email Not Subscribed, try Again",
      );
    }
  };

  // Get current year for copyright
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white w-full overflow-x-hidden font-['Roboto','Poppins','Inter',sans-serif] pb-0">
      {/* Footer Container */}
      <div className="max-w-[1586px] mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-8 sm:pt-8 sm:pb-6">
        {/* Main Links Grid: Company, Policies, Shopping, Categories, Social */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-4 sm:mb-6">
          {/* Company Links */}
          <div className="flex flex-col gap-2">
            <h3 className="font-['Poppins'] font-bold text-xl sm:text-2xl">
              Company
            </h3>
            <ul className="flex flex-col gap-2 text-sm">
              <li>
                <a href="about" className="hover:text-[#35A93E] block py-0.5">
                  About Life on plus
                </a>
              </li>
              <li>
                <a
                  href="/what-do-customer-say"
                  className="hover:text-[#35A93E] block py-0.5"
                >
                  What Do Customer Say
                </a>
              </li>
              <li>
                <a
                  href="https://www.lifeonplus.com/news_events.html"
                  className="hover:text-[#35A93E] block py-0.5"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  In the news
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="hover:text-[#35A93E] block py-0.5"
                >
                  Contact
                </a>
              </li>
              <li>
                <a
                  href="/partner-model"
                  className="hover:text-[#35A93E] block py-0.5"
                >
                  Partner Model
                </a>
              </li>
              {/* <li>
                <a
                  href="/company-refer"
                  className="hover:text-[#35A93E] block py-0.5"
                >
                  Refer & Earn
                </a>
              </li> */}
              <li>
                <a href="/faq" className="hover:text-[#35A93E] block py-0.5">
                  FAQs
                </a>
              </li>
              <li>
                <a
                  href="/channel-partner"
                  className="hover:text-[#35A93E] block py-0.5"
                >
                  Channel Partner
                </a>
              </li>
            </ul>
          </div>

          {/* Our Policies */}
          <div className="flex flex-col gap-2 sm:gap-3">
            <h3 className="font-['Poppins'] font-bold text-xl sm:text-2xl">
              Our Policies
            </h3>
            <ul className="flex flex-col gap-2 text-sm">
              <li>
                <a
                  href="/term-conditions"
                  className="hover:text-[#35A93E] block py-0.5"
                >
                  Terms and Conditions
                </a>
              </li>
              <li>
                <a
                  href="/privacy-policy"
                  className="hover:text-[#35A93E] block py-0.5"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/fees-and-payment"
                  className="hover:text-[#35A93E] block py-0.5"
                >
                  Fees and Payments Policy
                </a>
              </li>
              <li>
                <a
                  href="/shipping-policy"
                  className="hover:text-[#35A93E] block py-0.5"
                >
                  Shipping and Delivery Policy
                </a>
              </li>
              <li>
                <a
                  href="/refund-policy"
                  className="hover:text-[#35A93E] block py-0.5"
                >
                  Return, Refund and Cancellation
                </a>
              </li>
              <li>
                <a
                  href="/editorial-policy"
                  className="hover:text-[#35A93E] block py-0.5"
                >
                  Editorial Policy
                </a>
              </li>
              <li>
                <a
                  href="/vendor-policy"
                  className="hover:text-[#35A93E] block py-0.5"
                >
                  Vendor Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Shopping */}
          {/* <div className="flex flex-col gap-2">
            <h3 className="font-['Poppins'] font-bold text-xl sm:text-2xl">
              Shopping
            </h3>
            <ul className="flex flex-col gap-2 text-sm">
              <li>
                <a href="#" className="hover:text-[#35A93E] block py-0.5">
                  Browse by A-Z
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#35A93E] block py-0.5">
                  Browse by Manufacturers/Vendors
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#35A93E] block py-0.5">
                  Browse by Brands
                </a>
              </li>
              <li>
                <a
                  href="https://www.lifeonplus.com/blog.html"
                  className="hover:text-[#35A93E] block py-0.5"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Browse by Health Articles
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#35A93E] block py-0.5">
                  Browse by Offers/Coupons
                </a>
              </li>
              <li>
                <a href="/faq" className="hover:text-[#35A93E] block py-0.5">
                  FAQs
                </a>
              </li>
            </ul>
          </div> */}

          {/* Categories */}
          <div className="flex flex-col gap-2">
            <h3 className="font-['Poppins'] font-bold text-xl sm:text-2xl">
              Categories
            </h3>
            <ul className="flex flex-col gap-2 text-sm">
              {services?.slice(0, 10)?.map((category) => {
                return (
                  <li key={category?._id}>
                    <a
                      onClick={() => navigate(`/services/${category?._id}`)}
                      className="hover:text-[#35A93E] capitalize cursor-pointer block py-0.5"
                    >
                      {category?.course}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Social Media */}
          <div className="flex flex-col gap-3 sm:gap-4">
            <div className="flex flex-col gap-2">
              <h3 className="font-['Poppins'] font-bold text-xl sm:text-2xl">
                Social Media
              </h3>
              <div className="flex gap-1 sm:gap-2 flex-wrap">
                <a
                  href="https://www.facebook.com/lifeonplus.india/"
                  className="w-8 h-8 border border-white rounded-full flex items-center justify-center hover:bg-white hover:text-black transition flex-shrink-0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebookF className="text-sm" />
                </a>
                <a
                  href="https://x.com/Lifeonplus"
                  className="w-8 h-8 border border-white rounded-full flex items-center justify-center hover:bg-white hover:text-black transition flex-shrink-0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTwitter className="text-sm" />
                </a>
                <a
                  href="https://www.linkedin.com/company/lifeonplus/?viewAsMember=true"
                  className="w-8 h-8 border border-white rounded-full flex items-center justify-center hover:bg-white hover:text-black transition flex-shrink-0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedinIn className="text-sm" />
                </a>
                <a
                  href="https://www.instagram.com/lifeonplus.india/"
                  className="w-8 h-8 border border-white rounded-full flex items-center justify-center hover:bg-white hover:text-black transition flex-shrink-0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram className="text-sm" />
                </a>
                <a
                  href="https://api.whatsapp.com/send/?phone=91%206580136083&text=Hi+Lifeonplus&app_absent=0"
                  className="w-8 h-8 border border-white rounded-full flex items-center justify-center hover:bg-white hover:text-black transition flex-shrink-0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp className="text-sm" />
                </a>
                <a
                  href="https://youtube.com/@lifeonplus-india?si=WwhEFvtHo63hHDhm"
                  className="w-8 h-8 border border-white rounded-full flex items-center justify-center hover:bg-white hover:text-black transition flex-shrink-0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaYoutube className="text-sm" />
                </a>
              </div>
            </div>
            {/* <div className="flex flex-col gap-1 text-sm">
              <a href="forum" className="hover:text-[#35A93E] block py-0.5">
                Forum
              </a>
              <a href="refer" className="hover:text-[#35A93E] block py-0.5">
                Refer & Earn
              </a>
            </div> */}
            <h3 className="font-['Poppins'] font-bold text-base">
              Download Lifeonplus App
            </h3>
            <div className="flex flex-col gap-2">
              <img
                className="cursor-pointer h-[40px] w-[140px] object-contain bg-transparent"
                src="/googleplay.png"
                alt="google play"
                onClick={() =>
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.paxykop.lifeonplus",
                  )
                }
              />
              <img
                className="cursor-pointer h-[40px] w-[140px] object-contain bg-transparent"
                src="/appstore.png"
                alt="app store"
                onClick={() =>
                  window.open(
                    "https://apps.apple.com/us/app/lifeonplus-digital-health-card/id6739937070",
                  )
                }
              />
            </div>
            <div className="flex flex-col gap-2">
              <h3 className="font-['Poppins'] font-bold text-xl sm:text-2xl">
                Newsletter
              </h3>
              <p className="font-['Inter'] text-[10px] leading-tight">
                Get a free subscription to our health and fitness tips and stay
                tuned to our latest offers
              </p>
              <div className="flex flex-col sm:flex-row gap-1 sm:gap-2 w-full">
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full h-8 bg-gray-100 text-black text-sm px-2 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 flex-1"
                />
                <button
                  className="w-full sm:w-auto h-8 bg-green-500 text-white font-['Poppins'] font-medium text-sm rounded-md hover:bg-green-600 transition px-3"
                  onClick={() => subscribeNewsletter()}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Address Row - Full Width */}
        <div className="w-full mb-4 sm:mb-6">
          <h3 className="font-['Roboto'] font-bold text-sm sm:text-base">
            Address
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-4 sm:mb-6">
            <div className="flex flex-col gap-1">
              <h4 className="font-['Poppins'] font-semibold text-sm">
                Registered Office
              </h4>
              <p className="font-['Poppins'] text-sm leading-tight">
                # No.301, 3rd Floor, “MasterMind 1, Royal Palms”
                <br />
                Aarey Milk Colony, Goregaon (East),
                <br />
                Mumbai-400065, Maharashtra, India
              </p>
              <p className="font-['Poppins'] font-medium text-sm mt-1">
                GST: 27AAFCL7111F1ZQ
              </p>
              <p className="font-['Poppins'] font-medium text-sm">
                CIN: U79110MH2024PTC418580
              </p>
              <p className="font-['Poppins'] font-medium text-sm my-1">
                Certifications
              </p>
              <p className="font-['Poppins'] font-medium text-sm">
                ✅ HIPAA Compliant
              </p>
              <p className="font-['Poppins'] font-medium text-sm">
                ⚙️ ISO 9001 Certification – In Progress
              </p>
            </div>
            <div className="flex flex-col gap-1">
              <h4 className="font-['Poppins'] font-semibold text-sm">
                Branch Office
              </h4>
              <p className="font-['Poppins'] text-sm leading-tight">
                No. 15, Devraja Mudali Street, 1st Floor,
                <br />
                Park Town, Chennai - 600 003, Tamil Nadu, India
              </p>
              <img
                className="cursor-pointer"
                src="/Hipaa_logo.png"
                alt="logo"
                width={150}
              />
            </div>
            <div className="flex flex-col gap-1">
              <h4 className="font-['Poppins'] font-semibold text-sm">
                Branch Office
              </h4>

              <p className="font-['Poppins'] text-sm leading-tight">
                WeWork Cinnabar Hills, Embassy Golf Links Business Park,
                <br />
                SY# 13/2, Location No. 8, Challaghatta,
                <br />
                Bangalore - 560047, Karnataka, India
              </p>

              {/* Government Approval */}
              <div className="mt-4 flex items-center gap-4">
                {/* Logo */}
                <div className="bg-white rounded-md p-1 flex-shrink-0">
                  <img
                    src="/abba.png"
                    alt="ABDM & ABHA Compliant"
                    className="w-16 h-auto object-contain"
                  />
                </div>

                {/* Text */}
                <div className="flex-1 text-center">
                  <h5 className="text-white font-semibold text-sm">
                    ABDM & ABHA Compliant
                  </h5>

                  <p className="text-gray-300 text-xs leading-5 mt-1">
                    Approved by{" "}
                    <br/>
                    <span className="text-white font-semibold">
                      National Health Authority
                    </span>
                    <br />
                    Ministry of Health & Family Welfare,
                    <br />
                    Government of India.
                  </p>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <h4 className="font-['Poppins'] font-semibold text-sm">
                In Collaboration with Technical Partner
              </h4>

              <p className="font-['Poppins'] text-sm leading-6 text-gray-300">
                Paxykop Technologies Pte Ltd
                <br />
                L-39, MBFC, 10 Marina Blvd,
                <br />
                Singapore - 018983
              </p>

              <div className="mt-4">
                <img
                  src="/mii.png"
                  alt="Make in India"
                  className="h-20 md:h-24 w-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Website, Contact, Payment Partners Row - Full Width */}
        <div className="w-full flex flex-col lg:flex-row gap-4 lg:gap-6 justify-between items-start lg:items-center mb-4 sm:mb-6">
          {/* Website and Contact */}
          <div className="flex flex-col gap-2">
            <h3 className="font-['Roboto'] font-bold text-sm sm:text-base">
              Website
            </h3>
            <a
              href="https://www.lifeonplus.com"
              className="text-sm hover:text-[#35A93E] block py-0.5"
            >
              www.lifeonplus.com
            </a>
            <a
              href="https://www.lifeonplus.in"
              className="text-sm hover:text-[#35A93E] block py-0.5"
            >
              www.lifeonplus.in
            </a>
          </div>
          <div className="flex flex-col gap-2">
            <h3 className="font-['Roboto'] font-bold text-sm">Contact</h3>
            <div className="flex items-center gap-2 py-0.5">
              <div className="w-4 h-4 bg-gray-300 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-black text-[10px]">📞</span>
              </div>
              <a href="tel:9986880000" className="text-sm hover:text-[#35A93E]">
                99868 80000
              </a>
            </div>
            <div className="flex items-center gap-2 py-0.5">
              <div className="w-4 h-4 bg-gray-300 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-black text-[10px]">✉️</span>
              </div>
              <a
                href="mailto:info@lifeonplus.com"
                className="text-sm hover:text-[#35A93E]"
              >
                info@lifeonplus.com
              </a>
            </div>
          </div>

          {/* Payment Partners */}
          <div className="flex flex-col gap-2">
            <h3 className="font-['Poppins'] font-bold text-base sm:text-lg mb-1">
              Our Payment Partners
            </h3>
            <div className="flex flex-wrap gap-1 sm:gap-2">
              <img
                src="/gpay.png"
                alt="GPay"
                className="h-6 w-6 sm:h-8 sm:w-8 object-contain"
              />
              <img
                src="/phonpe.png"
                alt="PhonePe"
                className="h-6 w-6 sm:h-8 sm:w-8 object-contain"
              />
              <img
                src="/paytm.png"
                alt="Paytm"
                className="h-6 w-6 sm:h-8 sm:w-8 object-contain"
              />
              <img
                src="/simpl.png"
                alt="Simpl"
                className="h-6 w-6 sm:h-8 sm:w-8 object-contain"
              />
              <img
                src="/payment.png"
                alt="RuPay"
                className="h-6 w-6 sm:h-8 sm:w-8 object-contain"
              />
              <img
                src="/visa.png"
                alt="VISA"
                className="h-6 w-6 sm:h-8 sm:w-8 object-contain"
              />
              <img
                src="/card.png"
                alt="Mastercard"
                className="h-6 w-6 sm:h-8 sm:w-8 object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#061939] py-3">
        <div className="max-w-[1586px] mx-auto px-2 sm:px-4 lg:px-8 flex flex-col sm:flex-row justify-between items-center gap-2">
          <div className="flex flex-wrap gap-2 text-sm justify-center sm:justify-start">
            <a href="/privacy-policy" className="hover:text-[#35A93E]">
              Privacy Policy
            </a>
            <a href="/term-conditions" className="hover:text-[#35A93E]">
              Terms of Use
            </a>
            <a href="/refund-policy" className="hover:text-[#35A93E]">
              Sales and Refunds
            </a>
          </div>
          <p className="font-light text-sm text-center sm:text-right mt-1 sm:mt-0">
            © {currentYear} All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
